import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { BehaviorSubject, Subject, combineLatest, filter, takeUntil } from 'rxjs';
import { LgvFormUtilityService } from '../../../core/services/lgv-form-utility.service';
import { getProperty, setProperty } from 'dot-prop';

@Component({
    selector: 'lgv-formly-down-pct-amt',
    templateUrl: './formly-down-pct-amt.component.html',
    styleUrls: ['./formly-down-pct-amt.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class FormlyDownPctAmtComponent extends FieldType<FieldTypeConfig> implements OnInit, OnDestroy {

    residenceDurationForm: UntypedFormGroup;
    onDestroy$ = new Subject();
    residenceDurationInMonths: number;

    amtDown$ = new BehaviorSubject(0);
    pctDown$ = new BehaviorSubject(0);

    constructor(private fb: FormBuilder,
        private lgvFormSvc: LgvFormUtilityService
    ) {
        super();
    }

    ngOnInit(): void {

        this.lgvFormSvc.dataModel$.pipe(filter(f=> !!f), takeUntil(this.onDestroy$)).subscribe(x=>{

            let dataModel = this.lgvFormSvc.dataModel$.value;

            let basePath = 'loanApp.loanInfo';
            let purchPath = `${basePath}.purpose.name`;
            let purchValue = getProperty(dataModel, purchPath) || null;
            let isPurch = purchValue?.toUpperCase() === 'PURCHASE';

            let loanAmount = getProperty(dataModel, `${basePath}.loanAmount`) || null;
            let transactionAmount = getProperty(dataModel, isPurch ? `${basePath}.purchasePrice` : `${basePath}.appraisalValue`) || null;

            if(+loanAmount > 0 && +transactionAmount > 0){
                let downAmt = +transactionAmount - +loanAmount;
                let pctDown = (downAmt / +transactionAmount) * 100;

                if(downAmt > 0 && pctDown > 0){
                    this.amtDown$.next(downAmt);
                    this.pctDown$.next(pctDown);
                    return;
                }
            }

            this.amtDown$.next(0);
            this.pctDown$.next(0);

        });

    }

    ngOnDestroy() {
        this.onDestroy$.complete();
    }
}
